import { Grid } from "@mui/material";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { MprcInputStyles } from "components/filter/MprcInputStyles";
import { AutoCompleteDataModel, MprcAutoComplete } from "components/MprcAutoComplete";
import { AutoCompleteSuggestions, createAutoCompleteModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { AudienceFilterOptions } from "generated/CoreApi_v1";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IAdvFilterPickerProps } from "views/general/AdvancedFilter/interfaces";

////////////////////////////////////////////////////////////////////////////////

export const AudienceOptionPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { t } = useTranslation("shared");

    const { filter, onApply, onCancel } = props;

    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);
    const multiSelect = filter.canRepeat ?? false;

    const options = useRef<AutoCompleteDataModel[]>([
        createAutoCompleteModel(AudienceFilterOptions.ContainsAudience, t("AdvFilter.Picker.Audience.Options.ContainsAudienceText")),
        createAutoCompleteModel(AudienceFilterOptions.NotContainsAudience, t("AdvFilter.Picker.Audience.Options.NotContainsAudienceText")),
        createAutoCompleteModel(AudienceFilterOptions.ContainsRequiredAudience, t("AdvFilter.Picker.Audience.Options.ContainsRequiredAudienceText")),
        createAutoCompleteModel(AudienceFilterOptions.ContainsNotRequiredAudience, t("AdvFilter.Picker.Audience.Options.ContainsNotRequiredAudienceText")),
    ]);

    ///
    const getSuggestions = (searchText: string, offset: number, take: number): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            searchText = searchText.toLowerCase();
            const items = options.current;
            resolve({
                items: items.filter(x => x.label.toLowerCase().includes(searchText)),
                totalRows: items.length
            });
        });
    };


    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            }));
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <MprcAutoComplete
                    id="audienceOptionInput"
                    autoFocus
                    label={t("AdvFilter.Picker.Audience.AudienceLabel")}
                    placeholder={t("AdvFilter.Picker.Audience.Placeholder")}
                    multiSelect={multiSelect}
                    maxSuggestionCount={0}
                    selectedItems={selected}
                    onGetSuggestions={getSuggestions}
                    onChange={(items) => setSelected(items)}
                    onApply={handleApply}
                    onCancel={onCancel}
                    sx={MprcInputStyles.filter}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
